import type { SortOption } from "@/components/sortDropdown";

export const DRIVE_SCOPE_PARAM = "scope";
export const DRIVE_SCOPE_OWNED_VALUE = "owned";
export const DRIVE_SHARING_NAME_THRESHOLD = 3;
export const UNIFIED_DRIVE_SORT_STORAGE_KEY = "unified-drive-sorted-items-config";
export const DRIVE_PAGE_SIZE = 50;
export const DEFAULT_DRIVE_SORT: SortOption = { field: "created_at", direction: "desc" };
export const SPLIT_GRID_COLUMNS = "grid-cols-[2rem_minmax(0,1fr)_7rem_2rem]";
